<template>
  <v-btn
    v-if="userBelepve"
    icon
    @click.prevent="StatuszAllitas"
    v-bind="$attrs"
    :loading="loading"
    class="fontos-icon"
  >
    <i class="fa-bookmark" :class="iconType"></i>
  </v-btn>
</template>

<script>
import { mapGetters } from 'vuex';
import { NotificationFunctions } from '../../functions/NotificationFunctions';
import { eventBus } from '../../main';
import { hirService } from '../../services/HirService';
import { AppStoreTypes } from '../../store/modules/app';
import { timeout } from '../../utils/common';

export default {
  name: 'k-fontos-hir-icon',
  inheritAttrs: false,
  data() {
    return {
      loading: false,
      hirLocal: null,
    };
  },
  mounted() {
    eventBus.$on(this.fontosAllitasEventName, this.FontosAllitva);
  },
  beforeDestroy() {
    eventBus.$off(this.fontosAllitasEventName, this.FontosAllitva);
  },
  methods: {
    async StatuszAllitas() {
      this.loading = true;
      try {
        let valtozottFl = !this.hirLocal.Kedvelve;
        await hirService.SetKedvencHir({
          hirId: this.hir.Id,
          kedvencFl: valtozottFl,
        });
        eventBus.$emit(this.fontosAllitasEventName, {
          Id: this.hir.Id,
          Kedvelve: valtozottFl,
        });
      } catch (error) {
        NotificationFunctions.AjaxError({ error });
      }
      this.loading = false;
    },
    FontosAllitva(data) {
      let modifiedObject = {
        ...this.hir,
        ...data,
      };
      this.hirLocal = modifiedObject;
    },
  },
  computed: {
    ...mapGetters({
      user: AppStoreTypes.user.get,
    }),
    userBelepve() {
      return this.user?.Id > 0;
    },
    isFontos() {
      return this.hirLocal.Kedvelve;
    },
    iconType() {
      return this.isFontos ? 'fas' : 'far';
    },
    fontosAllitasEventName() {
      return 'fontos-allapot-valtas-' + this.hir.Id;
    },
  },
  watch: {
    hir: {
      handler() {
        this.hirLocal = this.hir;
      },
      immediate: true,
      deep: true,
    },
  },
  props: {
    hir: {
      type: Object,
    },
  },
};
</script>
